import { GuardedType, IsInterface } from "generic-type-guard";

import { isArrayOf, isObject, isObjectOf, isString } from "../../utilities/typeGuardUtils";

interface RootWithCorrelatedFachverfahrenKey {
	correlatedFachverfahrenKey: string;
}

interface DocumentWithCorrelatedFachverfahrenKey {
	root: RootWithCorrelatedFachverfahrenKey;
}

export const isDocumentWithCorrelatedFachverfahrenKey = isObjectOf<DocumentWithCorrelatedFachverfahrenKey>({
	root: isObjectOf<RootWithCorrelatedFachverfahrenKey>({
		correlatedFachverfahrenKey: isString
	})
});

interface TextbausteinImportNode {
	document: DocumentWithCorrelatedFachverfahrenKey;
	documentReference: string;
	children: TextbausteinImportNode[];
}

export interface TextbausteinImportData {
	nodes: TextbausteinImportNode[];
}

export function isTextbausteinImportData(e: any): e is TextbausteinImportNode {
	return (
		isObject(e) &&
		isObject(e.documentReference) &&
		isString(e.documentReference.docRef) &&
		isArrayOf(isTextbausteinImportData)(e.children)
	);
}

export type TextbausteinWitchIdentifier = GuardedType<typeof isTextbausteinDocumentWithIdentifier>;

export const isTextbausteinDocumentWithIdentifier = new IsInterface()
	.withProperties({
		document: isDocumentWithCorrelatedFachverfahrenKey,
		identifier: new IsInterface()
			.withProperties({
				id: isString,
				type: isString
			})
			.get()
	})
	.get();
